import { StoryboardSection } from "pages/media/types/";
import { useTemplateEditorStore } from "../../../store/useTemplateEditorStore";
import { TextEditable } from "./components/TextEditable";
import { Presenter } from "./components/Presenter";

interface TransitionPreviewProps {
  previewWidth: number;
  previewHeight: number;
  onSectionUpdate?: (
    sectionId: string,
    updates: Partial<StoryboardSection>
  ) => void;
  validateSectionUpdate?: (
    sectionUpdates: Partial<StoryboardSection>
  ) => boolean;
}

export const TransitionPreview = ({
  previewWidth,
  previewHeight,
  onSectionUpdate,
  validateSectionUpdate,
}: TransitionPreviewProps) => {
  const {
    titleStyle,
    setTitleStyle,
    currentChapter,
    setCurrentChapter,
    presenter,
  } = useTemplateEditorStore((store) => ({
    titleStyle: store.templateState.titleStyle,
    setTitleStyle: store.setTitleStyle,
    currentChapter: store.currentChapter,
    setCurrentChapter: store.setCurrentChapter,
    presenter: store.templateState.presenter,
  }));

  const displayTitle = currentChapter.topic;

  const handleTitleChange = (title: string) => {
    if (!validateSectionUpdate?.({ topic: title })) return;
    // Update currentChapter immediately so the UI reflects the change
    setCurrentChapter({
      ...currentChapter,
      topic: title,
    });
    onSectionUpdate?.(currentChapter.sectionId, { topic: title });
  };

  return (
    <>
      {titleStyle.fontAssetId && titleStyle.showTitle && (
        <TextEditable
          key={titleStyle.id}
          textItem={{
            id: "Title",
            ...titleStyle,
            content: displayTitle,
          }}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
          onChange={(params) => {
            setTitleStyle(params);
            if ("content" in params) {
              if (!params.content || params.content === displayTitle) return;
              handleTitleChange(params.content);
            }
          }}
        />
      )}
      {presenter.presenter && (
        <Presenter
          draggable={true}
          presenter={presenter}
          previewWidth={previewWidth}
          previewHeight={previewHeight}
        />
      )}
    </>
  );
};
